document.addEventListener("DOMContentLoaded", function () {

    let foilColour = document.querySelector('#foil-colour');
    let foilFinish = document.querySelector('#foil-finish');
    let glassine = document.querySelector('#glassine');
    let fontStyle = document.querySelector('#font-style');

    var foilColourSelector = document.querySelectorAll('input[type=radio][name="foil-colour-selector"]');
    var foilFinishSelector = document.querySelectorAll('input[type=radio][name="foil-finish-selector"]');
    var glassineSelector = document.querySelectorAll('input[type=radio][name="glassine"]');
    var fontStyleSelector = document.querySelectorAll('input[type=radio][name="font-style"]');

    if (typeof foilColourSelector !== 'undefined') {
        foilColourSelector.forEach((cone) => {
            cone.onchange = function () {
                foilColour.value = this.value;

                var mattFinishOpt = document.querySelector('input[type=radio][id="Matt"]');
                var shinyFinishOpt = document.querySelector('input[type=radio][id="Shiny"]');
                if (mattFinishOpt){
                    mattFinishOpt.parentNode.classList.remove('visually-hidden');
                    if (this.value === 'Rose gold foil') { //Hide the matt option
                        mattFinishOpt.checked = false;
                        shinyFinishOpt.checked = true;
                        foilFinish.value = shinyFinishOpt.value;
                        mattFinishOpt.parentNode.classList.add('visually-hidden');
                    } 
                }
               
                var foilColourSubtitle = document.querySelector('.foil-colour--subtitle');
                foilColourSubtitle.innerHTML = "";

                // if (this.value === 'Gold foil') { //Hide the matt option
                //     foilColourSubtitle.innerHTML = "Perfect for 50 years";
                // } 
                // if (this.value === 'Silver foil') { //Hide the matt option
                //     foilColourSubtitle.innerHTML = "Perfect for 25 years";
                // } 
            };
        });
    }

    if (typeof foilFinishSelector !== 'undefined') {
        foilFinishSelector.forEach((cone) => {
            cone.onchange = function () {
                foilFinish.value = this.value;
            };
        });
    }

    if (typeof fontStyleSelector !== 'undefined') {
        fontStyleSelector.forEach((style) => {
            style.onchange = function () {
                fontStyle.value = this.value;
            };
        });
    }

    if (typeof glassineSelector !== 'undefined') {
        glassineSelector.forEach((g) => {
            g.onchange = function () {
                glassine.value = this.value;
                let glassineSubtitle = document.querySelector('.glassineSubtitle');
                let glassineText = this.parentNode.querySelector('.subtitleText').innerHTML;
                glassineSubtitle.innerHTML = glassineText;
            };
        });
    }

    eventBus.on('variant:change', event => {
        let variant = event;
        console.log(`Variant changed => ${JSON.stringify(variant)}`);
        console.log(event.sectionId);

        setPremiumInput(event.sectionId);

    });

    // const inputs = document.querySelectorAll("input[type=text][data-premium=true]");
    // inputs.forEach(input => {
    //     input.addEventListener("input", updateValue);
    // });
   

    // const isEmpty = str => !str.trim().length;
    // function updateValue(e) {
    //     let sectionId = document.querySelector('.product-section').getAttribute('data-wetheme-section-id');
    //     if (!isEmpty(this.value)) {
    //         console.log(e.target.value);
    //         const sections = document.querySelectorAll(`product-swatch[data-section-id="${sectionId}"]`);

    //         sections.forEach(section => {
    //             const headerText = section.querySelector(".header.label-font").textContent;
    //             const checkedValue = section.querySelector('input[type=radio]').value;

    //             if (headerText.includes("Line 1")) {
    //                 console.log("Radio button value 1 is " + checkedValue);
    //                 section.querySelector('input[type=radio][value="Yes"]').click();
    //             } else if (headerText.includes("Line 2")) {
    //                 console.log("Radio button value 2 is " + checkedValue)
    //                 section.querySelector('input[type=radio][value="Yes"]').click();
    //             }
    //         });
    //     } else {
    //         console.log("Input is empty");
    //     }
    // }

    // const checkbox = document.querySelector('.text-line-one');

    // if (checkbox){
    //     checkbox.addEventListener('change', (event) => {
    //         var els = document.querySelectorAll(".header.label-font");
    //         var searchValue = "Line 1";
    //         var element;

    //         for (var i = 0; i < els.length; i++) {
    //             if (els[i].innerHTML.indexOf(searchValue) > -1) {
    //                 console.log("Checked");

    //                 element = els[i];
    //             }
    //         }
    //         if (event.currentTarget.checked) {
    //             //alert('checked');
    //             element.parentNode.parentNode.querySelector('input[type=radio][value="Yes"]').click();

    //         } else {
    //             //alert('not checked');
    //             element.parentNode.parentNode.querySelector('input[type=radio][value="No"]').click();
    //         }
    //     });
    // }
    
    // const checkbox1 = document.querySelector('.text-line-two');

    // if (checkbox1){
    //     checkbox1.addEventListener('change', (event) => {
    //         var els = document.querySelectorAll(".header.label-font");
    //         var searchValue = "Line 2";
    //         var element;

    //         for (var i = 0; i < els.length; i++) {
    //             if (els[i].innerHTML.indexOf(searchValue) > -1) {
    //                 console.log("Checked");

    //                 element = els[i];
    //             }
    //         }
    //         if (event.currentTarget.checked) {
    //             //alert('checked');
    //             element.parentNode.parentNode.querySelector('input[type=radio][value="Yes"]').click();

    //         } else {
    //             //alert('not checked');
    //             element.parentNode.parentNode.querySelector('input[type=radio][value="No"]').click();
    //         }
    //     });
    // }
    
    function handleCheckboxChange(checkboxSelector, searchValue) {
        const checkbox = document.querySelector(checkboxSelector);

        if (checkbox) {
            checkbox.addEventListener('change', (event) => {
                const elements = document.querySelectorAll(".header.label-font");
                let targetElement = null;

                elements.forEach(el => {
                    if (el.innerHTML.includes(searchValue)) {
                        console.log("Checked");
                        targetElement = el;
                    }
                });

                if (targetElement) {
                    const radioValue = event.currentTarget.checked ? "Yes" : "No";
                    targetElement.parentNode.parentNode.querySelector(`input[type=radio][value="${radioValue}"]`).click();
                }
            });
        }
    }

    handleCheckboxChange('.text-line-one', 'Line 1');
    handleCheckboxChange('.text-line-two', 'Line 2');
    handleCheckboxChange('.text-line-three', 'Line 3');

    let swatchSectionId = document.querySelector('.product-section').getAttribute('data-wetheme-section-id');
    console.log(swatchSectionId);
    setPremiumInput(swatchSectionId);
   
    function setPremiumInput(sectionId) {
        const sections = document.querySelectorAll(`product-swatch[data-section-id="${sectionId}"]`);

        sections.forEach(section => {
            const headerText = section.querySelector(".header.label-font").textContent;
            const checkedValue = section.querySelector('input[type=radio]:checked').value;

            if (headerText.includes("Line 1")) {
                updateInputState('line-one', checkedValue);
            } else if (headerText.includes("Line 2")) {
                updateInputState('line-two', checkedValue);
            }
        });

        function updateInputState(line, value) {
            const input = document.querySelector(`input[type=text][data-premium=true][data-line="${line}"]`);
            const checkbox = document.querySelector(`.text-${line}`);
            const isEnabled = value === "Yes";

            input.disabled = !isEnabled;
            input.value = isEnabled ? input.value : ''; // Clear value if disabled or value is "No"
            input.parentNode.classList.toggle("disabled-input", !isEnabled);
            if (isEnabled){
                checkbox.checked = true;
            }

        }

    }
  
});